import { atom } from 'recoil';

export const businessType = atom({
  key: 'businessType',
  default: "구매",
});
